import React from "react";

import { TabItem, Tabs } from "shared/ui";

import { useStopListContext } from "features/StopList/context";
import { StopListTab } from "features/StopList/types";

import { Badge, Label } from "./styles";

export const StopListTabs = () => {
    const state = useStopListContext();

    const renderLabel = (tab: StopListTab, text: string, count: number) => {
        const active = state.activeTab === tab;

        return (
            <Label $active={active}>
                {text}
                <Badge $active={active}>{count}</Badge>
            </Label>
        );
    };

    const tabs: TabItem<StopListTab>[] = [
        { key: "items", label: renderLabel("items", "Позиции", state.stopItemsCount) },
        {
            key: "categories",
            label: renderLabel("categories", "Категории", state.stopCategoriesCount),
        },
    ];

    return <Tabs value={state.activeTab} tabs={tabs} onChange={state.setActiveTab} />;
};
